<template>
  <div>
    <el-tree
      :data="mansuriptRepoTree"
      :props="defaultProps"
      @node-click="handleNodeClick"
      :highlight-current='hightLight'
      element-loading-text="拼命加载中"
      :expand-on-click-node='expandOnClick'
      node-key="id"
      :show-checkbox='showCheckbox'
      :check-on-click-node='false'
      ref='mansuriptTreeRef'
      :check-strictly='checkStrictly'
      v-loading="loading"
      @check-change='checkChange'
    >
      <span
        class="custom-tree-node"
        slot-scope="{ node, data }"
      >

        <span
          class="node_label"
          :title="node.label"
        >{{ node.label }}</span>

        <span
          class="el-iconfont el-icon-arrow-right"
          v-if='data.children && data.children.hasOwnProperty("length") && data.children.length>0 && !node.expanded'
        ></span>
        <span
          class="el-iconfont el-icon-arrow-down"
          v-if='data.children && data.children.hasOwnProperty("length") && data.children.length>0 && node.expanded'
        ></span>

      </span>
    </el-tree>
  </div>
</template>

<script>
import * as api from '../../../api'
import { getUrlCode } from '../../../utils/index.js'
export default {
  name: 'savetree',
  props: {
    hightLight: {
      type: Boolean,
      required: true
    },
    showCheckbox: {
      type: Boolean,
      required: true
    },

    checkStrictly: {
      type: Boolean,
      required: true
    }
  },
  components: {

  },
  mounted () {

  },
  created () {

  },
  destroyed () {

  },
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: function (data) {
          if (data.flag_repo) {
            return true
          }
        }
      },
      expandOnClick: true,
      mansuriptRepoTree: [],
      loading: false,

    }
  },
  computed: {

  },
  methods: {
    handleNodeClick (data, node, nodeSelf) {


    },
    checkChange (data, checked) {
      var type = ''
      if (typeof (eval(this.$parent.$parent.getOperateType)) == "function") {
        type = this.$parent.$parent.getOperateType()
      }
      if (type === 'oneArticleMove' || type === 'batchArticleMove' || type === 'batchArticleRestore') {
        if (checked) {
          var arr = this.$refs.mansuriptTreeRef.getCheckedNodes()
          for (var i = 0; i < arr.length; i++) {
            this.$refs.mansuriptTreeRef.setChecked(arr[i])
          }
          this.$refs.mansuriptTreeRef.setChecked(data.id, true)
          this.$emit('checkChangeFolder', this.$refs.mansuriptTreeRef.getCheckedNodes())
        }
      } else {
        this.$emit('checkChangeFolderList', this.$refs.mansuriptTreeRef.getCheckedNodes())
      }

    },

    //获取稿件库库列表
    getMansuriptData (data) {
      this.loading = true
      var type = ''
      if (data) {
        if (data[0].doc_type === 'document') {
          type = 'document'
        } else {
          type = 'article'
        }
      } else {
        type = 'article'
      }
      var saveTreetype = ''
      var moveArticleData = []
      if (typeof (eval(this.$parent.$parent.getOperateType)) == "function") {
        saveTreetype = this.$parent.$parent.getOperateType()
        moveArticleData = this.$parent.$parent.getMoveArticleInfo()
      }
      var isPublicRepo = true
      if (moveArticleData && moveArticleData.length > 0) {
        if (moveArticleData[0].id_repo.indexOf('repository-personal') === -1) {
          isPublicRepo = true
        } else {
          isPublicRepo = false
        }
      }
      var option = {
        ...this.$store.getters.baseOption,
        "params": {          // 必须字段：  参数
          "type": type,         // 必须字段：  库类型， 稿件库为 article，素材库为 material
        }
      }
      api._post(_REPOSITORYURL_ + 'api/repository/get_repo_tree', option).then((resp) => {
        if (resp.code == 200) {
          this.mansuriptRepoTree = resp.data
          if ((saveTreetype === 'oneArticleMove' || saveTreetype === 'batchArticleMove') && isPublicRepo) {
            for (var i = 0; i < this.mansuriptRepoTree.length; i++) {
              if (this.mansuriptRepoTree[i].id.indexOf('repository-personal') !== -1) {
                this.mansuriptRepoTree.splice(i, 1)
                break;
              }
            }
          }

        } else {
          this.mansuriptRepoTree = []
        }
        this.loading = false
      }).catch((error) => {
        this.mansuriptRepoTree = []
        this.loading = false
        console.log(error)
      })
    },

  }
}
</script>

<style lang='stylus' scoped></style>
